import {findQuestions} from './step.schema.utils.js';
import {getPointsFromConviction} from './conviction.points.js';
import moment from 'moment';
import products from './products.js';
import fields from "../schemes/form/fields.utils.js";

export const marketingHeadline = 'Marketing';
export const vehicleHeadLine = 'Vehicle';
export const proposerHeadline = 'Proposer';
export const policyHeadline = 'Policy';
export const homeHeadline = 'Home';
export const propertiesHeadline = 'Properties';
export const companyHeadline = 'Business';
export const contactHeadline = 'Contact';
export const courierHeadline = 'Courier';
export const boatHeadline = 'Boat';

const PERCENTAGE_VEHICLE = 'vehicle';
const PERCENTAGE_DRIVER = 'driver';
const PERCENTAGE_COMPANY = 'company';
const PERCENTAGE_BUSINESS = 'business';
const PERCENTAGE_POLICY = 'policy';
const PERCENTAGE_HOME = 'home';
const PERCENTAGE_PROPERTIES = 'properties';
const PERCENTAGE_PROPOSER = 'proposer';
const PERCENTAGE_CONTACT = 'contact';
const PERCENTAGE_COURIER = 'courier';
const PERCENTAGE_BOAT = 'boat';
const PERCENTAGE_CARAVAN = 'caravan';

export const percentageGroup = {
    PERCENTAGE_VEHICLE,
    PERCENTAGE_DRIVER,
    PERCENTAGE_COMPANY,
    PERCENTAGE_BUSINESS,
    PERCENTAGE_CONTACT,
    PERCENTAGE_COURIER,
    PERCENTAGE_POLICY,
    PERCENTAGE_HOME,
    PERCENTAGE_PROPOSER,
    PERCENTAGE_PROPERTIES,
    PERCENTAGE_BOAT,
    PERCENTAGE_CARAVAN,
};

export const progressbarRange = {
    [products.fresh_web_courier]: {
        [percentageGroup.PERCENTAGE_COURIER]: {min: 0, max: 8},
        [percentageGroup.PERCENTAGE_VEHICLE]: {min: 9, max: 20},
        [percentageGroup.PERCENTAGE_DRIVER]: {min: 25, max: 85},
        [percentageGroup.PERCENTAGE_POLICY]: {min: 87.5, max: 100},
    },
    [products.fresh_web_fast_food]: {
        [percentageGroup.PERCENTAGE_VEHICLE]: {min: 0, max: 20},
        [percentageGroup.PERCENTAGE_DRIVER]: {min: 25, max: 85},
        [percentageGroup.PERCENTAGE_POLICY]: {min: 87.5, max: 100},
    },
    [products.fresh_web_fleet]: {
        [percentageGroup.PERCENTAGE_COMPANY]: {min: 0, max: 28.5},
        [percentageGroup.PERCENTAGE_VEHICLE]: {min: 30, max: 48.5},
        [percentageGroup.PERCENTAGE_DRIVER]: {min: 50, max: 68.5},
        [percentageGroup.PERCENTAGE_POLICY]: {min: 70, max: 100},
    },
    [products.fresh_web_generic]: {
        [percentageGroup.PERCENTAGE_VEHICLE]: {min: 0, max: 20},
        [percentageGroup.PERCENTAGE_DRIVER]: {min: 25, max: 75},
        [percentageGroup.PERCENTAGE_POLICY]: {min: 80, max: 100},
    },
    [products.fresh_web_goods_in_transit]: {
        [percentageGroup.PERCENTAGE_DRIVER]: {min: 0, max: 50},
        [percentageGroup.PERCENTAGE_COMPANY]: {min: 55, max: 70},
        [percentageGroup.PERCENTAGE_POLICY]: {min: 75, max: 100},
    },
    [products.fresh_web_hgv]: {
        [percentageGroup.PERCENTAGE_VEHICLE]: {min: 0, max: 20},
        [percentageGroup.PERCENTAGE_DRIVER]: {min: 25, max: 85},
        [percentageGroup.PERCENTAGE_POLICY]: {min: 90, max: 100},
    },
    [products.fresh_web_home]: {
        [percentageGroup.PERCENTAGE_HOME]: {min: 0, max: 25},
        [percentageGroup.PERCENTAGE_DRIVER]: {min: 30, max: 70},
        [percentageGroup.PERCENTAGE_POLICY]: {min: 75, max: 100},
    },
    [products.fresh_web_landlord]: {
        [percentageGroup.PERCENTAGE_PROPERTIES]: {min: 0, max: 25},
        [percentageGroup.PERCENTAGE_PROPOSER]: {min: 30, max: 70},
        [percentageGroup.PERCENTAGE_POLICY]: {min: 75, max: 100},
    },
    [products.fresh_web_mini_bus]: {
        [percentageGroup.PERCENTAGE_VEHICLE]: {min: 0, max: 25},
        [percentageGroup.PERCENTAGE_DRIVER]: {min: 30, max: 70},
        [percentageGroup.PERCENTAGE_POLICY]: {min: 75, max: 100},
    },
    [products.fresh_web_motor_bike]: {
        [percentageGroup.PERCENTAGE_VEHICLE]: {min: 0, max: 15},
        [percentageGroup.PERCENTAGE_DRIVER]: {min: 20, max: 75},
        [percentageGroup.PERCENTAGE_POLICY]: {min: 80, max: 100},
    },
    [products.fresh_web_motor_home]: {
        [percentageGroup.PERCENTAGE_VEHICLE]: {min: 0, max: 15},
        [percentageGroup.PERCENTAGE_DRIVER]: {min: 20, max: 75},
        [percentageGroup.PERCENTAGE_POLICY]: {min: 80, max: 100},
    },
    [products.fresh_web_motor_trade]: {
        [percentageGroup.PERCENTAGE_COMPANY]: {min: 0, max: 15},
        [percentageGroup.PERCENTAGE_POLICY]: {min: 20, max: 35},
        [percentageGroup.PERCENTAGE_DRIVER]: {min: 40, max: 100},
    },
    [products.fresh_web_public_liability]: {
        [percentageGroup.PERCENTAGE_BUSINESS]: {min: 0, max: 35},
        [percentageGroup.PERCENTAGE_CONTACT]: {min: 35, max: 75},
        [percentageGroup.PERCENTAGE_POLICY]: {min: 80, max: 100},
    },
    [products.fresh_web_quad]: {
        [percentageGroup.PERCENTAGE_VEHICLE]: {min: 0, max: 15},
        [percentageGroup.PERCENTAGE_DRIVER]: {min: 20, max: 75},
        [percentageGroup.PERCENTAGE_POLICY]: {min: 80, max: 100},
    },
    [products.fresh_web_school]: {
        [percentageGroup.PERCENTAGE_VEHICLE]: {min: 0, max: 15},
        [percentageGroup.PERCENTAGE_DRIVER]: {min: 20, max: 75},
        [percentageGroup.PERCENTAGE_POLICY]: {min: 80, max: 100},
    },
    [products.fresh_web_car]: {
        [percentageGroup.PERCENTAGE_VEHICLE]: {min: 0, max: 20},
        [percentageGroup.PERCENTAGE_DRIVER]: {min: 22.5, max: 85},
        [percentageGroup.PERCENTAGE_POLICY]: {min: 87.5, max: 100},
    },
    [products.fresh_web_modified]: {
        [percentageGroup.PERCENTAGE_VEHICLE]: {min: 0, max: 20},
        [percentageGroup.PERCENTAGE_DRIVER]: {min: 22.5, max: 85},
        [percentageGroup.PERCENTAGE_POLICY]: {min: 87.5, max: 100},
    },
    [products.fresh_web_taxi]: {
        [percentageGroup.PERCENTAGE_VEHICLE]: {min: 0, max: 20},
        [percentageGroup.PERCENTAGE_DRIVER]: {min: 22.5, max: 85},
        [percentageGroup.PERCENTAGE_POLICY]: {min: 87.5, max: 100},
    },
    [products.fresh_web_travel]: {
        [percentageGroup.PERCENTAGE_DRIVER]: {min: 0, max: 65},
        [percentageGroup.PERCENTAGE_POLICY]: {min: 70, max: 100},
    },
    [products.fresh_web_van]: {
        [percentageGroup.PERCENTAGE_VEHICLE]: {min: 0, max: 22.5},
        [percentageGroup.PERCENTAGE_DRIVER]: {min: 25, max: 88.5},
        [percentageGroup.PERCENTAGE_POLICY]: {min: 90, max: 100},
    },
    [products.fresh_web_sme]: {
        [percentageGroup.PERCENTAGE_COMPANY]: {min: 0, max: 50},
        [percentageGroup.PERCENTAGE_DRIVER]: {min: 55, max: 85},
        [percentageGroup.PERCENTAGE_POLICY]: {min: 90, max: 100},
    },
    [products.fresh_web_boat]: {
        [percentageGroup.PERCENTAGE_BOAT]: {min: 0, max: 60},
        [percentageGroup.PERCENTAGE_DRIVER]: {min: 65, max: 85},
        [percentageGroup.PERCENTAGE_POLICY]: {min: 90, max: 100},
    },
    [products.fresh_web_caravan]: {
        [percentageGroup.PERCENTAGE_CARAVAN]: {min: 0, max: 25},
        [percentageGroup.PERCENTAGE_DRIVER]: {min: 30, max: 70},
        [percentageGroup.PERCENTAGE_POLICY]: {min: 75, max: 100},
    },
    [products.fresh_web_gap]: {
        [percentageGroup.PERCENTAGE_VEHICLE]: {min: 0, max: 40},
        [percentageGroup.PERCENTAGE_DRIVER]: {min: 40, max: 80},
        [percentageGroup.PERCENTAGE_POLICY]: {min: 85, max: 100},
    },
};

const boolOptions = [{key: true, value: 'yes'}, {key: false, value: 'no'}];
const defaultFields = {
    // property
    property_postcode: {
        label: 'What is the property postcode?',
        type: 'text',
        value: '',
        headline: propertiesHeadline,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_PROPERTIES,
    },
    property_total: {
        key: 'property_total',
        label: 'Number of Properties',
        type: 'select',
        value: '1',
        options: [],
        headline: propertiesHeadline,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_PROPERTIES,
    },
    property_use: {
        key: 'property_use',
        type: 'select',
        label: 'Property Use',
        value: '',
        options: [],
        required: true,
        headline: propertiesHeadline,
        percentage_group: percentageGroup.PERCENTAGE_PROPERTIES,
    },
    'property_types': {
        label: 'Property Types',
        info: 'What do you need the cover for?',
        type: 'multiselect',
        headline: propertiesHeadline,
        percentage_group: percentageGroup.PERCENTAGE_PROPERTIES,
    },
    'property_type_flat': {
        label: 'Flat',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'property_type_block_of_flats': {
        label: 'Block of Flats',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'property_type_room_only': {
        label: 'Room Only',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'property_type_house': {
        label: 'House',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'property_type_shop': {
        label: 'Shop',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'property_type_cafe': {
        label: 'Cafe',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'property_type_restaurant': {
        label: 'Restaurant',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'property_type_industrial': {
        label: 'Industrial',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'property_type_warehouse': {
        label: 'Warehouse',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'property_type_office': {
        label: 'Office',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'property_type_hotel': {
        label: 'Hotel',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'property_type_airbnb': {
        label: 'Airbnb',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'property_type_other': {
        label: 'Other',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    property_value: {
        key: 'property_value',
        type: 'number',
        label: 'Property Value (estimated overall value for all the properties)',
        value: '',
        options: [],
        required: true,
        headline: propertiesHeadline,
        percentage_group: percentageGroup.PERCENTAGE_PROPERTIES,
    },
    //boat
    craft_type: {
        label: 'Type of Craft',
        type: 'select',
        required: true,
        value: '',
        options: [],
        headline: boatHeadline,
        percentage_group: percentageGroup.PERCENTAGE_BOAT,
    },
    boat_material: {
        label: 'What Material is the boat made from?',
        type: 'select',
        required: true,
        value: '',
        options: [],
        headline: boatHeadline,
        percentage_group: percentageGroup.PERCENTAGE_BOAT,
    },
    kept_ashore: {
        label: 'Is the craft kept ashore?',
        type: 'bool',
        value: null,
        options: boolOptions,
        headline: boatHeadline,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_BOAT,
    },
    claims_or_accidents: {
        label: 'Any Accidents or Claims in relation to Boat Insurance?',
        type: 'bool',
        value: null,
        options: boolOptions,
        headline: boatHeadline,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_BOAT,
    },
    years_experience: {
        label: 'How many years experience do you have with this craft? ',
        type: 'number',
        value: null,
        autocomplete: 'off',
        placeholder: 'Years of experience',
        headline: boatHeadline,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_BOAT,
    },
    ncb_years_boat: {
        label: 'How many years boat no-claims bonus do you have?',
        type: 'number',
        value: '',
        required: true,
        autocomplete: 'off',
        placeholder: 'NCB Years - BOAT',
        skippable: 'No Bonus - Skip',
        headline: boatHeadline,
        percentage_group: percentageGroup.PERCENTAGE_BOAT,
    },
    //home
    standard_construction: {
        label: 'Is your home a standard construction?',
        type: 'bool',
        value: null,
        options: boolOptions,
        headline: homeHeadline,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_HOME,
    },
    history_subsidence: {
        label: 'Does the property have a History of Subsidence?',
        type: 'bool',
        value: null,
        options: boolOptions,
        headline: homeHeadline,
        percentage_group: percentageGroup.PERCENTAGE_HOME,
        required: true,
    },
    history_flooding: {
        label: 'Does the property have a History of Flooding?',
        type: 'bool',
        value: null,
        options: boolOptions,
        headline: homeHeadline,
        percentage_group: percentageGroup.PERCENTAGE_HOME,
        required: true,
    },
    history_thatched_roof: {
        label: 'Does the property have a History of Thatched Roof?',
        type: 'bool',
        value: null,
        options: boolOptions,
        headline: homeHeadline,
        percentage_group: percentageGroup.PERCENTAGE_HOME,
        required: true,
    },
    static_caravan: {
        label: 'Is it a Static Caravan?',
        type: 'bool',
        value: null,
        options: boolOptions,
        headline: homeHeadline,
        percentage_group: percentageGroup.PERCENTAGE_HOME,
        required: true,
    },
    // company
    company_turnover: {
        label: 'Company Turnover',
        type: 'select',
        required: true,
        value: '',
        options: [],
        headline: companyHeadline,
        percentage_group: percentageGroup.PERCENTAGE_COMPANY,
        placeholder: 'Company Turnover',
    },
    company_name: {
        label: 'What is the business trading name?',
        type: 'text',
        value: '',
        headline: companyHeadline,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_COMPANY,
    },
    company_age: {
        label: 'When was the business established? (Year)',
        type: 'date-drop-down',
        value: moment().format('YYYY'),
        autocomplete: 'off',
        dateOrder: ['year'],
        headline: companyHeadline,
        percentage_group: percentageGroup.PERCENTAGE_COMPANY,
        required: true,
    },
    company_year: {
        label: 'When was the business established? (Year)',
        type: 'date-drop-down',
        value: moment().format('YYYY'),
        autocomplete: 'off',
        dateOrder: ['year'],
        headline: companyHeadline,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_COMPANY,
    },
    business_type: {
        type: 'text',
        label: 'What is the Business you run?',
        value: '',
        skippable: 'Skip',
        headline: companyHeadline,
        percentage_group: percentageGroup.PERCENTAGE_COMPANY,
    },
    company_business: {
        label: 'Nature of business',
        type: 'auto-suggest',
        required: true,
        value: '',
        options: [],
        headline: companyHeadline,
        percentage_group: percentageGroup.PERCENTAGE_COMPANY,
    },

    //vehicle
    vrm: {
        type: 'vehicle-lookup-step',
        value: '',
        autocomplete: 'off',
        placeholder: 'Registration Number',
        headline: vehicleHeadLine,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    make: {
        label: 'Make',
        type: 'select',
        value: '',
        options: [],
        autocomplete: 'off',
        placeholder: 'Make',
        skip_question: true,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    model: {
        label: 'Model',
        type: 'text',
        autocomplete: 'off',
        placeholder: 'Model',
        value: '',
        skip_question: true,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    year: {
        label: 'Year of Manufacture',
        type: 'number',
        value: '',
        autocomplete: 'off',
        placeholder: 'Year',
        skip_question: true,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    colour: {
        label: 'colour',
        type: 'text',
        value: '',
        autocomplete: 'off',
        placeholder: 'Colour',
        skip_question: true,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    fuel: {
        label: 'fuel',
        type: 'text',
        value: '',
        autocomplete: 'off',
        placeholder: 'Fuel',
        skip_question: true,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    body_type: {
        label: `What type of vehicle do you want to insure?`,
        type: 'select',
        value: '',
        options: [],
        required: true,
        headline: vehicleHeadLine,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    seats: {
        label: 'How many passengers can you carry in your vehicle?',
        type: 'number',
        value: 4,
        autocomplete: 'off',
        placeholder: 'Seats',
        headline: vehicleHeadLine,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    engine: {
        label: 'What is the engine of the vehicle?(cc)',
        type: 'number',
        value: '',
        required: true,
        autocomplete: 'off',
        placeholder: 'Engine',
        skip_question: true,
        headline: vehicleHeadLine,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    owner: {
        label: 'Are you the vehicle owner?',
        type: 'bool',
        value: true,
        options: boolOptions,
        required: true,
        headline: vehicleHeadLine,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    owner_since: {
        label: 'When did you buy the vehicle?',
        type: 'date-drop-down',
        value: moment().format('DD/MM/YYYY'),
        required: true,
        autocomplete: 'off',
        placeholder: 'Owner Since',
        headline: vehicleHeadLine,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    impounded: {
        label: 'Has the vehicle been impounded?',
        type: 'bool',
        value: false,
        options: boolOptions,
        required: true,
        headline: vehicleHeadLine,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    personal_miles: {
        label: 'How many personal miles will the vehicle do a year?',
        type: 'number',
        value: 0,
        required: true,
        autocomplete: 'off',
        placeholder: 'Personal Miles',
        headline: vehicleHeadLine,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    business_miles: {
        label: 'How many business miles will the vehicle do a year?',
        type: 'number',
        value: '',
        required: true,
        autocomplete: 'off',
        placeholder: 'Business Miles',
        headline: vehicleHeadLine,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    electric: {
        label: 'Is an electric vehicle?',
        autocomplete: 'off',
        headline: vehicleHeadLine,
        type: 'bool',
        value: false,
        options: boolOptions,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    vehicle_dual_control: {
        label: 'Does the vehicle have Dual Control?',
        autocomplete: 'off',
        headline: vehicleHeadLine,
        type: 'bool',
        value: false,
        options: boolOptions,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    pdi_cover: {
        label: 'Do you have an PDI Cover?',
        autocomplete: 'off',
        headline: vehicleHeadLine,
        type: 'bool',
        value: false,
        options: boolOptions,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    adi_cover: {
        label: 'Do you have an ADI Cover?',
        autocomplete: 'off',
        headline: vehicleHeadLine,
        type: 'bool',
        value: false,
        options: boolOptions,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    ncb_years_private: {
        label: 'How many years private no-claims bonus do you have?',
        type: 'number',
        value: '',
        required: true,
        autocomplete: 'off',
        placeholder: 'NCB Years',
        skippable: 'No Bonus - Skip',
        headline: vehicleHeadLine,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    ncb_years_courier: {
        label: 'How many years courier no-claims bonus do you have?',
        type: 'number',
        value: '',
        required: true,
        autocomplete: 'off',
        placeholder: 'NCB Years - COURIER',
        skippable: 'No Bonus - Skip',
        headline: vehicleHeadLine,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    ncb_years_van: {
        label: 'How many years van no-claims bonus do you have?',
        type: 'number',
        value: '',
        required: true,
        autocomplete: 'off',
        placeholder: 'NCB Years - VAN',
        skippable: 'No Bonus - Skip',
        headline: vehicleHeadLine,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    ncb_years_taxi: {
        label: 'How many years taxi no-claims bonus do you have?',
        type: 'number',
        value: 0,
        autocomplete: 'off',
        placeholder: 'NCB Years - TAXI',
        skippable: 'No Bonus - Skip',
        headline: vehicleHeadLine,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    ncb_years_motor_trade: {
        label: 'How many years motor trade no-claims bonus do you have?',
        type: 'number',
        value: 0,
        required: true,
        autocomplete: 'off',
        placeholder: 'NCB Years - MOTOR TRADE',
        skippable: 'No Bonus - Skip',
        headline: vehicleHeadLine,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    keeper: {
        label: 'Who is the registered keeper of the vehicle?',
        type: 'select',
        value: 'proposer',
        options: [],
        required: true,
        headline: vehicleHeadLine,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    road_use: {
        label: 'Is the vehicle for Road Use?',
        type: 'bool',
        value: false,
        options: boolOptions,
        headline: vehicleHeadLine,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    weight_over_35: {
        label: 'Is the vehicle over 3.5 tonne?',
        type: 'bool',
        value: false,
        options: boolOptions,
        required: true,
        headline: vehicleHeadLine,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    weight_over_75: {
        label: 'over 7.5 tonne?',
        type: 'bool',
        value: false,
        options: boolOptions,
        headline: vehicleHeadLine,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    ops_licence: {
        label: 'Do you have an Operators Licence?',
        autocomplete: 'off',
        headline: vehicleHeadLine,
        type: 'bool',
        value: true,
        options: boolOptions,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    ops_licence_pending: {
        label: 'Do you have an Operators Licence Pending?',
        autocomplete: 'off',
        headline: vehicleHeadLine,
        type: 'bool',
        value: '',
        options: boolOptions,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    business_use: {
        label: 'Is the vehicle for Business Use?',
        autocomplete: 'off',
        headline: vehicleHeadLine,
        type: 'bool',
        value: true,
        options: boolOptions,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    hire_vehicle_lease_use: {
        label: 'Is the vehicle used for Self Drive Hire?',
        autocomplete: 'off',
        headline: vehicleHeadLine,
        type: 'bool',
        value: false,
        options: boolOptions,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    value: {
        label: 'Vehicle Value',
        type: 'number',
        prepend: '£',
        value: '',
        autocomplete: 'off',
        // todo limit minimum 100
        placeholder: 'Value',
        headline: vehicleHeadLine,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    private_hire: {
        label: 'Is the vehicle used for Private Hire?',
        type: 'bool',
        value: false,
        options: boolOptions,
        headline: vehicleHeadLine,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    taxi_uber: {
        label: 'Are you using the vehicle for Uber?',
        type: 'bool',
        value: '',
        options: boolOptions,
        headline: vehicleHeadLine,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    public_hire: {
        label: 'Is the vehicle used for Public Hire?',
        type: 'bool',
        value: false,
        options: boolOptions,
        headline: vehicleHeadLine,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    taxi_badge_year: {
        label: 'When did you get your first Taxi badge?',
        type: 'date-drop-down',
        value: moment().format('MM/YYYY'),
        autocomplete: 'off',
        dateOrder: ['year', 'month'],
        headline: vehicleHeadLine,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    number_of_vehicles: {
        label: 'How many vehicles do you want to insure?',
        type: 'number',
        value: 2,
        autocomplete: 'off',
        placeholder: 'Number of Vehicles',
        headline: vehicleHeadLine,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    taxi_psv_licence: {
        label: 'Do you have a Public Service Vehicle (PSV) licence?',
        type: 'bool',
        value: false,
        options: boolOptions,
        headline: vehicleHeadLine,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    taxi_pco_licence: {
        label: 'Do you have a Public Carriage Office (PCO) licence?',
        type: 'bool',
        value: false,
        options: boolOptions,
        headline: vehicleHeadLine,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    haulage_use: {
        label: 'Is the vehicle used for haulage?',
        type: 'bool',
        value: '',
        options: boolOptions,
        headline: vehicleHeadLine,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    vehicle_types: {
        label: 'Vehicles',
        info: 'Please select vehicle types that you want to insure.',
        type: 'multiselect',
        headline: vehicleHeadLine,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    vans: {
        label: 'Vans',
        type: 'bool',
        value: false,
        options: boolOptions,
        skip_question: true,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    cars: {
        label: 'Cars',
        type: 'bool',
        value: false,
        options: boolOptions,
        skip_question: true,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    motorbikes: {
        label: 'Motor Bikes',
        type: 'bool',
        value: false,
        options: boolOptions,
        skip_question: true,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    pickups: {
        label: 'Pickups',
        type: 'bool',
        value: false,
        options: boolOptions,
        skip_question: true,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    trucks: {
        label: 'Trucks',
        type: 'bool',
        value: false,
        options: boolOptions,
        skip_question: true,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    taxis: {
        label: 'Taxis',
        type: 'bool',
        value: false,
        options: boolOptions,
        skip_question: true,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    minibuses: {
        label: 'Minibuses',
        type: 'bool',
        value: false,
        options: boolOptions,
        skip_question: true,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    other: {
        label: 'Other',
        type: 'bool',
        value: false,
        options: boolOptions,
        skip_question: true,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    has_modifications_more: {
        label: 'Does the vehicle have any modifications?',
        type: 'bool',
        value: false,
        options: boolOptions,
        headline: vehicleHeadLine,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    kit_car: {
        label: 'Is a kit car?',
        type: 'bool',
        value: false,
        options: boolOptions,
        headline: vehicleHeadLine,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    contact_name: {
        label: `Contact Name`,
        placeholder: 'Contact Name',
        type: 'text',
        value: '',
        required: true,
        headline: proposerHeadline,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    },
    // driver
    first_name: {
        label: `First Name`,
        placeholder: 'First Name',
        type: 'text',
        value: '',
        required: true,
        autocomplete: 'given-name',
        headline: proposerHeadline,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    },
    last_name: {
        key: 'last_name',
        label: `Surname`,
        placeholder: 'Last Name',
        type: 'text',
        value: '',
        required: true,
        autocomplete: 'family-name',
        headline: proposerHeadline,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    },
    gender: {
        label: 'Gender',
        type: 'select',
        value: '',
        options: [],
        required: true,
        headline: proposerHeadline,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    },
    telephone: {
        label: `Telephone Number`,
        placeholder: 'Telephone',
        type: 'text',
        value: '',
        required: true,
        autocomplete: 'tel',
        headline: proposerHeadline,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    },
    email: {
        label: 'Email Address',
        placeholder: 'Email Address',
        type: 'email',
        value: '',
        autocomplete: 'email',
        headline: proposerHeadline,
        skippable: 'Skip Email',
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    },
    date_of_birth: {
        label: 'Date of birth',
        type: 'date-drop-down',
        value: moment().format('DD/MM/YYYY'),
        required: true,
        autocomplete: 'bday',
        placeholder: 'Date of Birth',
        headline: proposerHeadline,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    },
    postcode: {
        key: 'postcode',
        label: 'What is your home post code?',
        placeholder: 'postcode',
        type: 'address-lookup-step',
        value: '',
        required: true,
        autocomplete: 'postal-code',
        headline: proposerHeadline,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    },
    address1: {
        label: 'Address Line 1',
        placeholder: 'Address Line 1',
        value: '',
        type: 'text',
        required: true,
        autocomplete: 'address-line1',
        skip_question: true,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    },
    address2: {
        label: 'Address Line 2',
        placeholder: 'Address Line 2',
        value: '',
        type: 'text',
        autocomplete: 'address-line2',
        skip_question: true,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    },
    address3: {
        label: 'Address Line 3',
        placeholder: 'Address Line 3',
        type: 'text',
        value: '',
        autocomplete: 'address-line3',
        skip_question: true,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    },
    address4: {
        label: 'Address Line 4',
        placeholder: 'Address Line 4',
        type: 'text',
        value: '',
        autocomplete: 'address-line4',
        skip_question: true,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    },
    city: {
        label: 'City',
        placeholder: 'City',
        type: 'text',
        value: '',
        required: true,
        autocomplete: 'off',
        skip_question: true,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    },
    uk_since: {
        label: 'Have you lived in the UK since birth?',
        value: true,
        type: 'bool',
        required: true,
        options: boolOptions,
        headline: proposerHeadline,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    },
    uk_since_date: {
        label: 'On what date did you move to the UK?',
        value: moment().format('DD/MM/YYYY'),
        type: 'date-drop-down',
        autocomplete: 'off',
        placeholder: 'Uk since birth',
        required: true,
        headline: proposerHeadline,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    },
    taxi_council: {
        label: `What is your taxi licencing authority?`,
        value: '',
        type: 'auto-suggest',
        fdisplayClearButton: true,
        options: [],
        headline: proposerHeadline,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    },
    shipment: {
        label: 'What do you deliver?',
        type: 'select',
        value: false,
        options: [],
        required: true,
        headline: courierHeadline,
        percentage_group: percentageGroup.PERCENTAGE_COURIER,
    },
    licence_type: {
        label: `What type of driving licence do you have?`,
        type: 'select',
        value: 'full',
        options: [],
        required: true,
        headline: proposerHeadline,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    },
    licence_date: {
        label: `When did you pass your driving licence test?`,
        value: moment().format('DD/MM/YYYY'),
        type: 'date-drop-down',
        required: true,
        autocomplete: 'off',
        placeholder: 'Licence Date',
        headline: proposerHeadline,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    },
    hgv_licence: {
        label: 'Do you have a HGV licence?',
        headline: proposerHeadline,
        type: 'bool',
        value: true,
        options: boolOptions,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    },
    hgv_licence_date: {
        label: `HGV Licence Date of Issue`,
        type: 'date-drop-down',
        value: moment().format('DD/MM/YYYY'),
        required: true,
        autocomplete: 'off',
        headline: proposerHeadline,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    },
    lgv_licence: {
        label: 'Do you have a LGV licence?',
        headline: proposerHeadline,
        type: 'bool',
        value: '',
        options: boolOptions,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    },
    lgv_licence_date: {
        label: `LGV Licence Date of Issue`,
        type: 'date-drop-down',
        value: moment().format('DD/MM/YYYY'),
        required: true,
        autocomplete: 'off',
        headline: proposerHeadline,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    },
    occupation_waste_licence: {
        label: 'Do you have any Waste Licence?',
        type: 'bool',
        value: false,
        options: boolOptions,
        headline: proposerHeadline,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    },
    occupation_0_type: {
        label: `What is your primary occupation?`,
        value: '',
        type: 'auto-suggest',
        required: true,
        options: [],
        displayClearButton: true,
        headline: proposerHeadline,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    },
    occupation_0_more: {
        label: 'Do you have a second occupation?',
        type: 'bool',
        value: false,
        options: boolOptions,
        headline: proposerHeadline,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    },
    occupation_0_full_time: {
        label: `Is your primary occupation full time?`,
        type: 'bool',
        value: false,
        options: boolOptions,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
        headline: proposerHeadline,
    },
    occupation_1_type: {
        label: `What is the second occupation?`,
        value: '',
        type: 'auto-suggest',
        required: true,
        options: [],
        headline: proposerHeadline,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    },
    occupation_1_full_time: {
        label: `Is the second occupation full time?`,
        type: 'bool',
        value: false,
        options: boolOptions,
        required: true,
        headline: proposerHeadline,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    },
    has_convictions_more: {
        label: 'Have you received any motoring convictions in the last 5 years?',
        type: 'bool',
        value: false,
        options: boolOptions,
        headline: proposerHeadline,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    },
    has_mot_convictions: {
        label: 'Have you received any motoring convictions in the last 5 years?',
        type: 'bool',
        value: false,
        options: boolOptions,
        headline: proposerHeadline,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    },
    has_driving_convictions: {
        label: 'Have you had any motoring convictions in the last 5 years?',
        type: 'bool',
        value: null,
        options: boolOptions,
        headline: proposerHeadline,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    },
    has_claims: {
        label: 'Have you made any claims in the last 5 years?',
        type: 'bool',
        value: null,
        options: boolOptions,
        headline: proposerHeadline,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    },
    has_claims_more: {
        label: 'Have you made any claims in the last 5 years?',
        type: 'bool',
        value: false,
        options: boolOptions,
        headline: proposerHeadline,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    },
    has_criminal_convictions: {
        label: 'Does the driver have any unspent non-motoring convictions?',
        type: 'bool',
        value: null,
        options: boolOptions,
        headline: proposerHeadline,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    },
    has_another_driver_more: {
        key: 'has_another_driver_more',
        label: 'Do you want to insure any additional drivers on the policy?',
        type: 'bool',
        value: false,
        options: boolOptions,
        headline: proposerHeadline,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    },
    has_another_vehicle: {
        label: 'Do you drive any other vehicle?',
        type: 'bool',
        value: false,
        options: boolOptions,
        headline: proposerHeadline,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    },
    employment_status: {
        label: `What is the driver's employment status?`,
        value: '',
        type: 'select',
        required: true,
        options: [],
        headline: proposerHeadline,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    },
    has_medical_conditions: {
        label: 'Has the driver any medical condition?',
        type: 'bool',
        value: false,
        options: boolOptions,
        headline: policyHeadline,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    },
    occupation_student_living_at_home: {
        label: 'Is the driver a student living at home?',
        type: 'bool',
        value: false,
        options: boolOptions,
        headline: proposerHeadline,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    },
    // policy
    motor_trade_types: {
        label: 'Characteristics',
        info: 'What do you need the cover for?',
        type: 'multiselect',
        headline: policyHeadline,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    premises_cover: {
        label: 'premises',
        type: 'bool',
        value: false,
        options: boolOptions,
        headline: policyHeadline,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    motor_trade_recovery: {
        label: 'recovery',
        type: 'bool',
        value: false,
        options: boolOptions,
        headline: policyHeadline,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,

    },
    number_of_drivers: {
        label: 'How many drivers do you want to insure?',
        type: 'number',
        value: 2,
        required: true,
        autocomplete: 'nope',
        placeholder: 'Number of drivers',
        headline: policyHeadline,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    motor_trade_delivery: {
        label: 'delivery',
        type: 'bool',
        value: false,
        options: boolOptions,
        headline: policyHeadline,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    motor_trade_park: {
        label: 'car park',
        type: 'bool',
        value: false,
        options: boolOptions,
        headline: policyHeadline,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    motor_trade_valeting: {
        label: 'valeting',
        type: 'bool',
        value: false,
        options: boolOptions,
        headline: policyHeadline,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    motor_trade_body_shop: {
        label: 'body shop',
        type: 'bool',
        value: false,
        options: boolOptions,
        headline: policyHeadline,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    motor_trade_repairs: {
        label: 'repairs',
        type: 'bool',
        value: false,
        options: boolOptions,
        headline: policyHeadline,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    motor_trade_mot: {
        label: 'MOT',
        type: 'bool',
        value: false,
        options: boolOptions,
        headline: policyHeadline,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    motor_trade_service: {
        label: 'service',
        type: 'bool',
        value: false,
        options: boolOptions,
        headline: policyHeadline,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    motor_trade_buy_sell: {
        label: 'buy-sell',
        type: 'bool',
        value: false,
        options: boolOptions,
        headline: policyHeadline,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    motor_trade_scrap: {
        label: 'scrap',
        type: 'bool',
        value: false,
        options: boolOptions,
        headline: policyHeadline,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    caravan_park: {
        label: 'caravan park',
        type: 'bool',
        value: false,
        options: boolOptions,
        headline: policyHeadline,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    motor_trade_from: {
        label: 'Postcode of business trading address',
        type: 'select',
        value: '',
        options: [],
        required: true,
        headline: policyHeadline,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    business_postcode: {
        label: 'Postcode of business trading address',
        type: 'text',
        autocomplete: 'off',
        placeholder: 'Business Postcode',
        required: true,
        headline: policyHeadline,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    driving_restrictions: {
        label: 'Who will be driving the vehicles?',
        type: 'select',
        value: '',
        options: [],
        required: true,
        headline: policyHeadline,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },

    dob_youngest_driver: {
        label: 'What is the date of birth of the youngest driver?',
        value: moment().format('DD/MM/YYYY'),
        type: 'date-drop-down',
        headline: policyHeadline,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    dob_oldest_driver: {
        label: 'What is the date of birth of the oldest driver?',
        value: moment().format('DD/MM/YYYY'),
        type: 'date-drop-down',
        headline: policyHeadline,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    cover_date: {
        label: 'When do you want the policy to start?',
        type: 'date-drop-down',
        value: moment().format('DD/MM/YYYY'),
        required: true,
        autocomplete: 'off',
        placeholder: 'Cover Date',
        headline: policyHeadline,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
        minYear: moment().format('YYYY'),
        maxYear: moment().add(10, 'year').format('YYYY'),
    },
    cover_duration: {
        label: 'Are you looking for a 12 month insurance policy?',
        type: 'select',
        value: '',
        options: [{key: '12 months', value: 'yes'}, {key: 'short term', value: 'no'}],
        headline: policyHeadline,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    cover_type: {
        type: 'select',
        label: 'What is the preferred level of cover?',
        value: '',
        options: [],
        required: true,
        headline: policyHeadline,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    cover_level: {
        type: 'number',
        label: 'Cover level £',
        value: '',
        required: true,
        headline: policyHeadline,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    use_covered: {
        type: 'select',
        label: 'Covered',
        value: '',
        options: [],
        required: true,
        headline: policyHeadline,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    best_price: {
        label: 'What is the best price you had so far?',
        type: 'number',
        value: '',
        prepend: '£',
        required: true,
        autocomplete: 'off',
        placeholder: 'Best Price',
        skippable: 'Skip Best Price',
        headline: policyHeadline,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    black_box: {
        label: 'Would you consider a telematics / black box policy?',
        type: 'bool',
        value: false,
        options: boolOptions,
        headline: policyHeadline,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    previous_policy_cancelled: {
        label: 'Have you had any previously cancelled policies?',
        type: 'bool',
        value: false,
        options: boolOptions,
        required: true,
        headline: policyHeadline,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    claims_experience: {
        label: 'Have you held a previous Fleet Insurance policy in the last 12 months?',
        type: 'bool',
        value: false,
        options: boolOptions,
        headline: policyHeadline,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    //marketing
    marketing: {
        label: 'Marketing',
        info: 'From time to time we may send you marketing messages which may be of interest to you. Please select which of the methods you are happy for us to use.',
        type: 'marketing',
        headline: marketingHeadline,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    marketing_phone: {
        label: 'Call',
        type: 'bool',
        value: null,
        options: boolOptions,
        skip_question: true,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    marketing_email: {
        label: 'Email',
        type: 'bool',
        value: null,
        options: boolOptions,
        skip_question: true,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    marketing_sms: {
        label: 'SMS',
        type: 'bool',
        value: null,
        options: boolOptions,
        skip_question: true,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    short_term: {
        label: 'Is a Short Term Policy?',
        type: 'bool',
        value: null,
        options: boolOptions,
        required: true,
        headline: policyHeadline,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    travel_type: {
        type: 'select',
        label: 'What type of travel is it?',
        value: '',
        options: [],
        required: true,
        headline: policyHeadline,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    destination: {
        type: 'select',
        label: 'What is your destination?',
        value: '',
        options: [],
        required: true,
        headline: policyHeadline,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    travel_estimated_time: {
        label: 'Estimated travel time (in days)',
        type: 'number',
        value: '',
        required: true,
        autocomplete: 'off',
        placeholder: '1,2,3...',
        headline: policyHeadline,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    hazardous_activities: {
        label: "Do you intend to participate in activities considered dangerous during your trip?",
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
        headline: policyHeadline,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    has_another_traveller_more: {
        key: 'has_another_traveller_more',
        label: 'Do you want to insure any additional traveller on the policy?',
        type: 'bool',
        value: false,
        options: boolOptions,
        headline: proposerHeadline,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    },

    driving_restriction: {
        label: 'Driving Restriction',
        type: 'select',
        value: '',
        options: [],
        required: true,
        headline: vehicleHeadLine,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },

    driver_details: {
        label: 'Driver Details',
        info: '',
        styles: {
            size: {
                xs: 12
            },
        },
        type: 'multiselect',
        headline: proposerHeadline,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    },
    ...fields.title,
    mileage: {
        ...fields.mileage,
        label: 'How many personal miles will the vehicle do a year?',
        autocomplete: 'off',
        placeholder: '1000',
        headline: vehicleHeadLine,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    overnight_location: {
        ...fields.overnight_location,
        headline: vehicleHeadLine,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    },
    // public liability
    has_employees: {
        label: 'Do you have any employees?',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
        headline: policyHeadline,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    requires_employees_liability_cover: {
        label: 'Do you need employees liability cover?',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: false,
        headline: policyHeadline,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
};

export {defaultFields};

const step_fields_utils = {
    defaultFields,
    headlines: {
        marketingHeadline,
        vehicleHeadLine,
        proposerHeadline,
        companyHeadline,
        policyHeadline,
        homeHeadline,
    },
    occupation_x_type: index => ({
        label: `What is the driver's ${index + 1} occupation?`,
        key: `occupation_${index}_type`,
        value: '',
        type: 'auto-suggest',
        required: true,
        options: [],
        headline: `Proposer Occupation #${index + 1}`,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    }),
    occupation_x_more: index => ({
        key: `occupation_${index}_more`,
        label: 'Do you have any additional occupation?',
        type: 'bool',
        value: false,
        options: boolOptions,
        headline: `Proposer Occupation #${index + 1}`,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    }),
    conviction_x_type: (driver, index) => ({
        key: `conviction_${index}_type`,
        headline: `${driver} Conviction ${index + 1}`,
        label: 'What kind of conviction was it?',
        type: 'select',
        value: '',
        options: [],
        autocomplete: 'off',
        placeholder: 'Conviction Type',
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    }),
    conviction_x_ban: (driver, index) => ({
        key: `conviction_${index}_ban`,
        label: 'Did this lead to a driving ban?',
        type: 'bool',
        value: false,
        options: boolOptions,
        headline: `${driver} Conviction ${index + 1}`,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    }),
    conviction_x_more: (driver, index) => ({
        key: `convictions_${index}_more`,
        type: 'bool',
        value: false,
        options: boolOptions,
        label: `${driver === 'Proposer\'s' ? 'Have you' : 'Has the driver'} received any additional convictions in the last 5 years?`,
        headline: `${driver} Conviction ${index + 1}`,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    }),
    conviction_x_points: (driver, index) => ({
        key: `conviction_${index}_points`,
        label: 'How many penalty points were awarded for this offense?',
        type: 'select',
        value: null,
        headline: `${driver} Conviction ${index + 1}`,
        options: [],
        hiddenValue: null,
        options_modifier: (schema, key) => {
            const _key = key.replace('_points', '_type');
            const {current} = findQuestions(schema, {key: _key});
            if (current) {
                return getPointsFromConviction(current.value);
            }
            return [];
        },
        data_modifier_btn: (schema, key) => {
            const _key = key.replace('_points', '_type');
            const {current} = findQuestions(schema, {key: _key});
            if (current) {
                return {value: getPointsFromConviction(current.value)[0].value, label: 'Unsure'};
            }
            return {value: 0, label: 'Unsure'};
        },
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    }),
    claim_x_type: (driver, index) => ({
        label: 'What kind of claim was it?',
        key: `claim_${index}_type`,
        type: 'select',
        value: '',
        options: [],
        autocomplete: 'off',
        placeholder: 'Claim Type',
        headline: `${driver} Claim ${index + 1}`,
        required: true,
        orderOptions: false,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    }),
    claim_x_date: (driver, index) => ({
        label: 'Date of claim',
        key: `claim_${index}_date`,
        type: 'date-drop-down',
        value: moment().format('DD/MM/YYYY'),
        autocomplete: 'off',
        placeholder: 'Claim Date',
        minYear: moment().subtract(5, 'year').format('YYYY'),
        headline: `${driver} Claim ${index + 1}`,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    }),
    claim_x_more: (driver, index) => ({
        key: `claim_${index}_more`,
        label: `${driver === 'Proposer\'s' ? 'Have you made' : 'Has the driver made'} any additional claims in the last 5 years?`,
        type: 'bool',
        value: false,
        options: boolOptions,
        headline: `${driver} Claim ${index + 1}`,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    }),
    driver_x_name: (index) => ({
        key: `driver_${index}_name`,
        label: `What is their full name`,
        value: '',
        type: 'text',
        autocomplete: 'nope',
        placeholder: 'Name',
        headline: `Driver ${index + 1}`,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    }),
    driver_x_date_of_birth: index => ({
        key: `driver_${index}_date_of_birth`,
        label: `Date of Birth`,
        type: 'date-drop-down',
        value: moment().format('DD/MM/YYYY'),
        autocomplete: 'off',
        placeholder: 'Date of Birth',
        headline: `Driver ${index + 1}`,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    }),
    traveller_x_date_of_birth: index => ({
        key: `traveller_${index}_date_of_birth`,
        label: `Date of Birth`,
        type: 'date-drop-down',
        value: moment().format('DD/MM/YYYY'),
        autocomplete: 'off',
        placeholder: 'Date of Birth',
        headline: `Traveller ${index + 1}`,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    }),
    traveller_x_name: (index) => ({
        key: `traveller_${index}_name`,
        label: `What is their full name`,
        value: '',
        type: 'text',
        autocomplete: 'nope',
        placeholder: 'Name',
        headline: `Traveller ${index + 1}`,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    }),
    traveller_x_more: (index) => ({
        key: `traveller_${index}_more`,
        label: 'Do you want to insure any additional traveller on the policy?',
        type: 'bool',
        value: false,
        options: boolOptions,
        headline: `Traveller ${index + 1}`,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    }),
    driver_x_relationship: index => ({
        key: `driver_${index}_relationship`,
        label: `Relationship to the proposer`,
        type: 'select',
        value: '',
        options: [],
        headline: `Driver ${index + 1}`,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    }),
    has_another_driver_more: (index) => ({
        key: `driver_${index}_date_of_birth`,
        label: `What is their date of birth`,
        type: 'date-drop-down',
        value: moment().format('DD/MM/YYYY'),
        autocomplete: 'nope',
        placeholder: 'Date of Birth',
        headline: `Driver ${index + 1}`,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    }),
    driver_x_licence_type: (index) => ({
        key: `driver_${index}_licence_type`,
        label: `What licence type do they hold`,
        type: 'select',
        value: '',
        options: [],
        headline: `Driver ${index + 1}`,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    }),
    driver_x_licence_date: (index) => ({
        key: `driver_${index}_licence_date`,
        label: `When did they pass the driving test?`,
        value: moment().format('DD/MM/YYYY'),
        type: 'date-drop-down',
        autocomplete: 'nope',
        placeholder: 'Licence Date',
        headline: `Driver ${index + 1}`,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    }),
    driver_x_claims: index => ({
        key: `driver_${index}_claims`,
        label: `How many claims has the driver had?`,
        value: 0,
        type: 'number',
        autocomplete: 'off',
        placeholder: 'Claims',
        headline: `Driver ${index + 1}`,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    }),
    driver_x_convictions: index => ({
        key: `driver_${index}_convictions`,
        label: `How many convictions has the driver had?`,
        value: 0,
        type: 'number',
        autocomplete: 'off',
        placeholder: 'Convictions',
        headline: `Driver ${index + 1}`,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    }),
    driver_x_points: index => ({
        key: `driver_${index}_points`,
        label: `How many points has the driver lost?`,
        value: 0,
        type: 'number',
        placeholder: 'Points',
        headline: `Driver ${index + 1}`,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    }),
    driver_x_criminal_convictions: index => ({
        key: `driver_${index}_criminal_convictions`,
        label: `How many criminal convictions has the driver had?`,
        value: 0,
        type: 'number',
        autocomplete: 'off',
        placeholder: 'Criminal Convictions',
        headline: `Driver ${index + 1}`,
        required: true,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    }),
    driver_x_more: (index) => ({
        key: `driver_${index}_more`,
        label: 'Do you want to insure any additional drivers on the policy?',
        type: 'bool',
        value: false,
        options: boolOptions,
        headline: `Driver ${index + 1}`,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    }),
    modification_x_type: index => ({
        label: `Modification ${index + 1}`,
        key: `vehicle_modification_${index}_type`,
        value: '',
        type: 'auto-suggest',
        required: true,
        options: [],
        headline: `Vehicle Modification #${index + 1}`,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    }),
    modification_x_more: index => ({
        key: `modification_${index}_more`,
        label: 'Does the vehicle have any additional modification?',
        type: 'bool',
        value: false,
        options: boolOptions,
        headline: `Vehicle Modification #${index + 1}`,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
    }),
    medical_condition_x_more: index => ({
        key: `medical_condition_${index}_more`,
        label: 'Do you have any additional medical condition?',
        type: 'bool',
        value: false,
        options: boolOptions,
        headline: `Medical Condition #${index + 1}`,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    }),
    medical_condition_x_type: index => ({
        label: `Medical Condition ${index + 1}`,
        key: `medical_condition_${index}_type`,
        value: '',
        type: 'text',
        required: true,
        headline: `Medical Condition #${index + 1}`,
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
    }),
    marketing_fields: {
        key: 'marketing',
        label: 'Marketing',
        info: 'From time to time we may send you marketing messages which may be of interest to you. Please select which of the methods you are happy for us to use.',
        type: 'marketing',
        headline: marketingHeadline,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
};
export default step_fields_utils;
